import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faFileAlt } from '@fortawesome/free-solid-svg-icons';

const ClaimsProcessingDetailsModal = ({ isOpen, onClose, claim, formatAmount, formatDate }) => {
  if (!isOpen || !claim) return null;

  const rows = [
    { label: 'Batch No.', value: claim.batch_no },
    { label: 'Transaction No.', value: claim.trans_no },
    { label: 'LOA No.', value: claim.loa_no },
    { label: 'Member Name', value: claim.member_name },
    { label: 'Corporate', value: claim.corp_name },
    { label: 'Provider Name', value: claim.provider_name },
    { label: 'Provider Code', value: claim.provider_code },
    { label: 'Coverage Code', value: claim.coverage_code },
    { label: 'Plan Code', value: claim.plan_code },
    { label: 'LOA Amount', value: formatAmount(claim.amount) },
    { label: 'Claim Amount', value: formatAmount(claim.c_amount) },
    { label: 'Received Date', value: formatDate(claim.received_date) },
    { label: 'Due Date', value: formatDate(claim.due_date) },
    { label: 'Transaction Date', value: formatDate(claim.trans_date) },
    { label: 'SOA No.', value: claim.soa_no },
    { label: 'Doctor Name', value: claim.doctor_name },
    { label: 'Chief Complaint', value: claim.chief_complaint },
    { label: 'Claim Status', value: claim.claim_status },
    { label: 'Status Label', value: claim.status },
    { label: 'Claim Processor', value: claim.claim_processor },
    { label: 'Claim Processed Date', value: formatDate(claim.claim_processed_date) },
    { label: 'Claim Remarks', value: claim.claim_remarks },
    { label: 'Bill No.', value: claim.bill_no },
    { label: 'Diagnosis', value: claim.diagnosis },
    { label: 'RTP Tag', value: claim.rtp_tag },
    { label: 'Trans Flag Status', value: claim.trans_flag_status },
    { label: 'Spec Transmittal', value: claim.spec_transmittal },
    { label: 'Stale Tag', value: claim.stale_tag },
  ];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[85vh] overflow-hidden">
        <div className="p-6 border-b border-slate-100 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center">
              <FontAwesomeIcon icon={faFileAlt} />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-slate-800">Claim Details</h2>
              <p className="text-sm text-slate-500">View complete claim information</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-slate-500 hover:text-slate-700 transition-colors"
            aria-label="Close modal"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="p-6 overflow-y-auto max-h-[65vh]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {rows.map((row) => (
              <div key={row.label} className="flex flex-col gap-1">
                <span className="text-xs font-semibold uppercase text-slate-400">{row.label}</span>
                {row.label === 'Status Label' && row.value ? (
                  <div className="text-sm text-slate-800">
                    <span dangerouslySetInnerHTML={{ __html: row.value }} />
                  </div>
                ) : (
                  <span className="text-sm text-slate-800 break-words">
                    {row.value === null || row.value === undefined || row.value === '' ? '-' : row.value}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="p-6 border-t border-slate-100 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-slate-200 text-slate-800 rounded-lg hover:bg-slate-300 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClaimsProcessingDetailsModal;
